/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { Gender } from 'app/shared/model/enumerations/gender.model';

export interface ISymptom {
  id?: string;
  name?: string | null;
  gender?: keyof typeof Gender | null;
  widgetType?: string | null;
  startDate?: number | null;
  endDate?: number | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  ucid?: string | null;
}

export const defaultValue: Readonly<ISymptom> = {
  active: false,
  draft: false,
};
